const stickyMediaContentSplit = new window.Swiper(
	'.block-sticky-media-content-split .sticky-media-content-split-slider',
	{
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 20,
		allowTouchMove: false,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
	}
);

const observeSlider = (slider: typeof window.Swiper) => {
	if (slider && slider.el.nodeType) {
		const stickyContentMediaIndex: { [key: string]: number } = {};
		slider.slides.forEach((item: HTMLElement, index: number) => {
			const blockID = item.getAttribute('data-block-id') as string;
			stickyContentMediaIndex[blockID] = index;
		});

		const observerCallback = (entries: Array<IntersectionObserverEntry>) => {
			entries.forEach((entry: IntersectionObserverEntry) => {
				if (entry.isIntersecting) {
					slider.slideTo(stickyContentMediaIndex[entry.target.id]);
				}
			});
		};

		const observer = new IntersectionObserver(observerCallback, {
			rootMargin: '-50% 0px -50% 0px',
			threshold: 0,
		});

		const silderItems: NodeListOf<HTMLElement> | undefined = slider?.el
			?.closest('.block-sticky-media-content-split')
			?.querySelectorAll('.block-media');

		if (silderItems) {
			silderItems.forEach((scroller: HTMLElement) => {
				if (scroller) {
					observer.observe(scroller);

					// Manually trigger the callback if it's already in view
					const rect = scroller.getBoundingClientRect();
					if (rect.top < window.innerHeight && rect.bottom > 0) {
						slider.slideTo(stickyContentMediaIndex[scroller.id]);
					}
				}
			});
		}
	}
};

if (stickyMediaContentSplit) {
	if (Array.isArray(stickyMediaContentSplit)) {
		stickyMediaContentSplit.forEach((slider: typeof window.Swiper) => {
			observeSlider(slider);
		});
	} else {
		observeSlider(stickyMediaContentSplit);
	}
}

const contentMediaSplits = document.querySelectorAll('.block-content-media-split');

const imagesContainer = document.querySelector(
	'.block-sticky-media-content-split__images-container'
) as HTMLElement;

const isDesktopView = () => {
	const breakpoints = window.impBreakpoints;
	const mediaQuery = breakpoints
		? `(min-width: ${parseInt(breakpoints.md)}px)`
		: '(min-width: 768px)';
	return window.matchMedia(mediaQuery).matches;
};

const calculateMaxHeight = () => {
	if (!contentMediaSplits || !imagesContainer) return;

	const splitsArray = Array.from(contentMediaSplits) as HTMLElement[];
	if (splitsArray.length === 0) return;

	// Only calculate padding on desktop
	if (!isDesktopView()) return;

	const firstBlock = splitsArray[0];

	const componentMedia = imagesContainer.querySelector('.component-media') as HTMLElement;

	if (!componentMedia) return;

	const firstBlockRect = firstBlock.getBoundingClientRect();
	const containerRect = componentMedia.getBoundingClientRect();

	const lastBlock = splitsArray[splitsArray.length - 1];
	const lastBlockRect = lastBlock.getBoundingClientRect();

	const spacingTop = Math.abs((containerRect.height - firstBlockRect.height) / 2);
	const spacingBottom = Math.abs((containerRect.height - lastBlockRect.height) / 2);

	imagesContainer.style.paddingTop = `${Math.max(spacingTop, 0)}px`;
	imagesContainer.style.paddingBottom = `${Math.max(spacingBottom, 0)}px`;

	// Calculate sticky top after padding is applied and layout recalculates.
	requestAnimationFrame(() => {
		const viewportHeight = window.innerHeight;
		const outerBoxRect = imagesContainer.getBoundingClientRect();
		const innerBoxRect = componentMedia.getBoundingClientRect();

		const innerOffsetFromTop = innerBoxRect.top - outerBoxRect.top;

		// Get navigation heights from CSS variables
		const headerHeightFull = parseInt(
			getComputedStyle(document.documentElement)
				.getPropertyValue('--headerHeightFull')
				.replace('px', '') || '0'
		);
		const secondaryNavHeight = parseInt(
			getComputedStyle(document.documentElement)
				.getPropertyValue('--secondaryNavHeight')
				.replace('px', '') || '0'
		);

		const totalNavHeight = headerHeightFull + secondaryNavHeight;

		// Calculate top to center image, accounting for navigation heights.
		const stickyTop =
			(viewportHeight - totalNavHeight) / 2 -
			innerOffsetFromTop -
			innerBoxRect.height / 2 +
			totalNavHeight;

		imagesContainer.style.setProperty('--sticky-top', `${stickyTop}px`);
	});
};

window.addEventListener('resize', calculateMaxHeight);

window.addEventListener('load', () => {
	calculateMaxHeight();
});
